import { Flex, Text, Tooltip } from "@chakra-ui/react";
import { getAssetLongName } from "@syla/shared/helpers/assets/getAssetLongName";
import { getAssetShortName } from "@syla/shared/helpers/assets/getAssetShortName";
import React from "react";
import { TaxOutcomeDetail } from "../../../../../helper/aggregateLedgerTaxOutcomes";
import { NumberStyler } from "../../../../../helper/NumberStyler";
import { useTransactionsStore } from "../../../../../store/transactionsStore";
import { ImageWithMissingSrc } from "../../../../atoms/ImageWithMissingSrc";
import { SkeletonRect } from "../../../../atoms/Skeletons";
import { TableCell, TableRow, TableHeaderCell, TableHeaderRow } from "./Table";

export function TaxDetailsHeaders(): React.ReactElement {
  return (
    <TableHeaderRow>
      <TableHeaderCell>
        <Text>Classification</Text>
      </TableHeaderCell>
      <TableHeaderCell>
        <Text>Quantity</Text>
      </TableHeaderCell>
      <TableHeaderCell>
        <Text>Asset</Text>
      </TableHeaderCell>
      <TableHeaderCell justify="flex-end">
        <Text>Outcome</Text>
      </TableHeaderCell>
    </TableHeaderRow>
  );
}

export function TaxDetailsRow(
  taxOutcomeDetail: TaxOutcomeDetail,
): React.ReactElement {
  const isInvalid = useTransactionsStore((state) => state.refreshing);

  return (
    <TableRow>
      <TableCell>
        <Flex direction="column">
          <SkeletonRect isLoaded={!isInvalid}>
            <Text noOfLines={2}>{taxOutcomeDetail.classification}</Text>
            <Text
              noOfLines={1}
              fontSize="sm"
              fontWeight="light"
              color="gray.600"
            >
              {taxOutcomeDetail.subClassification}
            </Text>
          </SkeletonRect>
        </Flex>
      </TableCell>
      <TableCell>
        <SkeletonRect isLoaded={!isInvalid}>
          <NumberStyler
            fontSize="md"
            num={taxOutcomeDetail.amount}
            smartRound
          />
        </SkeletonRect>
      </TableCell>
      <TableCell>
        <ImageWithMissingSrc
          src={taxOutcomeDetail.asset.image}
          alt=""
          w="2rem"
          h="2rem"
          mr="0.5rem"
          isLoading={isInvalid}
        />
        <SkeletonRect isLoaded={!isInvalid}>
          <Tooltip label={getAssetLongName(taxOutcomeDetail.asset)}>
            <Text noOfLines={1}>
              {getAssetShortName(taxOutcomeDetail.asset)}
            </Text>
          </Tooltip>
        </SkeletonRect>
      </TableCell>
      <TableCell justify="flex-end">
        <SkeletonRect isLoaded={!isInvalid}>
          <NumberStyler
            fontSize="md"
            num={taxOutcomeDetail.outcome}
            unit="currency"
            colored
          />
        </SkeletonRect>
      </TableCell>
    </TableRow>
  );
}
